// src/feature-module/Visiting/VisitingList.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { message, DatePicker, Spin } from "antd";
import Swal from "sweetalert2";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  RotateCcw,
  CheckCircle,
  Edit,
  Eye,
  X,
  Share,
  MoreVertical,
} from "feather-icons-react";
import Table from "../../../core/pagination/datatable.jsx";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import CommonFooter from "../../../core/common/footer/commonFooter.jsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import axios from "axios";
import { ROLL_CALL_API_BASE_URL } from "../RollCall/RollCallConfig/RollCallConfig";

// import PropTypes from "prop-types";

import AddVisit from "./AddVisit.jsx";
const { RangePicker } = DatePicker;

const VisitorList = () => {
  const [selectedVisitType, setSelectedVisitType] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [showAdd, setShowAdd] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [isFullDay, setIsFullDay] = useState(false);
  const [visitCanvas, setVisitCanvas] = useState({
    show: false,
    mode: "view",
    record: null,
    currentStep: 1,
  });
  const closeCanvas = () => {
    setVisitCanvas({
      show: false,
      mode: "view",
      record: null,
      currentStep: 1,
    });
  };
  const isView = visitCanvas.mode === "view";
  const editableFields = ["Mobile", "Duration", "StartDateTime"];
  const isFieldEditable = (fieldName) => {
    if (visitCanvas.mode === "view") return false;
    if (visitCanvas.mode === "edit") {
      return editableFields.includes(fieldName);
    }
    return true; // for add mode
  };
  const navigate = useNavigate();
  const renderWithTooltip = (text, maxLength = 15) => {
    if (!text) return "N/A";

    const displayText =
      text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
      <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
        <span style={{ cursor: "pointer" }}>{displayText}</span>
      </OverlayTrigger>
    );
  };

  //columns
  const columns = [
    {
      title: "Visitor Name",
      dataIndex: "Name",
      key: "Name",
      render: (text) => renderWithTooltip(text, 15),
      sorter: (a, b) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Date & Time",
      key: "StartDateTime",
      render: (_, r) => formatDate(r.StartDateTime),
      sorter: (a, b) => new Date(a.StartDateTime) - new Date(b.StartDateTime),
    },
    {
      title: "VisitType",
      dataIndex: "VisitType",
      key: "VisitType",
      sorter: (a, b) => a.VisitType - b.VisitType,
      render: (value) => visitTypeMap[value] || "Unknown",
    },
    {
      title: "MeetingWith",
      dataIndex: "HostedByName",
      key: "HostedByName",
      render: (text) => renderWithTooltip(text, 15),
      sorter: (a, b) => a.HostedByName.localeCompare(b.HostedByName),
    },
    // {
    //     title: "Requestedby",
    //     dataIndex: "RequestedByName",
    //     key: "RequestedByName",
    //     render: (text) => renderWithTooltip(text, 12),
    //     sorter: (a, b) => a.RequestedByName.localeCompare(b.RequestedByName),
    // },

    {
      title: "Purpose",
      dataIndex: "Purpose",
      key: "Purpose",
      render: (text) => renderWithTooltip(text, 15),
      sorter: (a, b) => a.Purpose.localeCompare(b.Purpose),
    },
    {
      title: "Check In&Out",
      key: "checkInOut",
      render: (_, record) => {
        const checkIn = record.CheckInTime || "N/A";
        const checkOut = record.CheckOutTime || "N/A";
        const value = `${checkIn} - ${checkOut}`;

        return renderWithTooltip(value, 14);
      },
      sorter: (a, b) =>
        (a.CheckInTime || "").localeCompare(b.CheckInTime || ""),
    },
    {
      title: "Status",
      key: "Status",
      render: (_, record) => (
        <span className={`badge bg-${getStatusColor(record.Status)} badge-xs`}>
          {statusMap[record.Status] || "Unknown"}
        </span>
      ),
      sorter: (a, b) => a.Status - b.Status,
    },
    //     {
    //   title: "Status",
    //   key: "Status",
    //   render: (_, record) => {

    //     const statusText = statusMap[record.Status] || "Unknown";
    //     const color = `var(--bs-${getStatusColor(record.Status)})`;

    //     return (
    //       <span
    //         title={statusText}
    //         style={{
    //           display: "inline-block",
    //           width: 12,
    //           height: 12,
    //           borderRadius: "50%",
    //           backgroundColor: color,
    //         }}
    //       />
    //     );
    //   },
    //   sorter: (a, b) => a.Status - b.Status,
    // }
    {
      title: "Action",
      key: "Action",
      // render: (_, record) => (
      //     <div className="action-table-data">
      //         <div className="edit-delete-action">

      //             <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>}>
      //                 <Link
      //                     className="me-2 p-1"
      //                     onClick={() =>
      //                         setVisitCanvas({ show: true, mode: "view", record, currentStep: 1, })
      //                     }
      //                 >
      //                     <Eye />
      //                 </Link>
      //             </OverlayTrigger>

      //             <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
      //                 <Link
      //                     className="me-2 p-1"
      //                     onClick={() =>
      //                         setVisitCanvas({ show: true, mode: "edit", record, currentStep: 1, })
      //                     }
      //                 >
      //                     <Edit />
      //                 </Link>
      //             </OverlayTrigger>

      //             <OverlayTrigger placement="top" overlay={<Tooltip>
      //                 {record.Status === 0 ? "Approve Visit" : "Already Approved"}
      //             </Tooltip>}>
      //                 <Link className="me-2 p-1">
      //                     <CheckCircle
      //                         className={`feather-check text-success ${record.Status !== 0 ? "disabled-icon" : "clickable-icon"
      //                             }`}
      //                         onClick={() => {
      //                             if (record.Status === 0) handleApprove(record);
      //                         }}
      //                         style={{
      //                             cursor: record.Status === 0 ? "pointer" : "not-allowed",
      //                             opacity: record.Status !== 0 ? 0.4 : 1,
      //                         }}
      //                     />
      //                 </Link>
      //             </OverlayTrigger>
      //             <OverlayTrigger
      //                 placement="top"
      //                 overlay={<Tooltip>Share QR on WhatsApp</Tooltip>}
      //             >
      //                 <Link
      //                     className="me-2 p-1"
      //                     onClick={() => handleShareWhatsApp(record)}
      //                 >
      //                     <Share className="text-success" />
      //                 </Link>
      //             </OverlayTrigger>

      //             <OverlayTrigger placement="top" overlay={<Tooltip>Reject</Tooltip>}>
      //                 <Link
      //                     className="me-2 p-1"
      //                     onClick={() => handleReject(record)}
      //                 >
      //                     <X className="text-danger" />
      //                 </Link>
      //             </OverlayTrigger>

      //         </div>
      //     </div>
      // ),
      render: (_, record) => (
        <div className="action-table-data">
          <div className="dropdown">
            {/* Three Dots Button */}
            <button
              className="btn btn-sm btn-light"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <MoreVertical size={18} />
            </button>

            {/* Dropdown Menu */}
            <ul className="dropdown-menu dropdown-menu-end">
              {/* View */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() =>
                    setVisitCanvas({
                      show: true,
                      mode: "view",
                      record,
                      currentStep: 1,
                    })
                  }
                >
                  <Eye size={16} className="me-2" />
                  View
                </button>
              </li>

              {/* Edit */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() =>
                    setVisitCanvas({
                      show: true,
                      mode: "edit",
                      record,
                      currentStep: 1,
                    })
                  }
                >
                  <Edit size={16} className="me-2" />
                  Edit
                </button>
              </li>

              {/* Approve */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  disabled={record.Status !== 0}
                  onClick={() => {
                    if (record.Status === 0) {
                      handleApprove(record);
                    }
                  }}
                >
                  <CheckCircle size={16} className="me-2 text-success" />
                  {record.Status === 0 ? "Approve" : "Approved"}
                </button>
              </li>

              {/* Share */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => handleShareWhatsApp(record)}
                >
                  <Share size={16} className="me-2 text-success" />
                  Reshare QR
                </button>
              </li>

              {/* Reject */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => handleReject(record)}
                >
                  <X size={16} className="me-2 text-danger" />
                  Reject
                </button>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];
  const formatDate = (isoString) => {
    if (!isoString) return "N/A";

    const [datePart, timePart] = isoString.split("T");

    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");

    return `${day}-${month}-${year} ${hour}:${minute}`;
  };
  const rangePresets = [
    {
      label: "Today",
      value: [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: "This Week",
      value: [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "This Year",
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
  ];
  const visitTypeOptions = [
    { label: "All Types", value: 0 },
    { label: "Meeting", value: 1 },
    { label: "Client", value: 2 },
    { label: "Vendor", value: 3 },
    { label: "Candidate", value: 4 },
    { label: "Other", value: 5 },
  ];
  const statusOptions = [
    { label: "All Status", value: undefined },
    { label: "Pending", value: 0 },
    { label: "Approved", value: 1 },
    { label: "Check-In", value: 2 },
    { label: "Check-Out", value: 3 },
    { label: "Expired", value: 4 },
  ];
  const durationOptions = [
    { value: "30", label: "30 Minutes" },
    { value: "60", label: "1 Hour" },
    { value: "120", label: "2 Hours" },
    { value: "180", label: "3 Hours" },
  ];
  const statusMap = Object.fromEntries(
    statusOptions.map((s) => [s.value, s.label]),
  );
  const visitTypeMap = Object.fromEntries(
    visitTypeOptions
      .filter((v) => v.value !== 0)
      .map((v) => [v.value, v.label]),
  );
  const onRangeChange = (dates) => {
    setDateRange(dates);
    if (dates) {
      fetchVisitingData({
        visitType: selectedVisitType,
        status: selectedStatus,
        fromDate: dates[0].format("DD-MM-YYYY"),
        toDate: dates[1].format("DD-MM-YYYY"),
      });
    } else {
      fetchVisitingData({
        visitType: selectedVisitType,
        status: selectedStatus,
      });
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "warning";
      case 1:
        return "success";
      case 2:
        return "info";
      case 3:
        return "primary";
      case 4:
        return "danger";
      default:
        return "secondary";
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");
    const userDataString = sessionStorage.getItem("userData");

    if (userDataString) {
      setUserData(JSON.parse(userDataString));
    }

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const fetchVisitingData = async (filters = {}) => {
    if (!superIdData || !tokenData) return;

    setLoading(true);

    try {
      const { data } = await axios.get(
        `${ROLL_CALL_API_BASE_URL}Visitor/Pass/getvisitorsList`,
        {
          params: {
            SuperId: superIdData,
            HostedBy: filters.hostedBy || 0,
            status:
              filters.status && filters.status !== "all" ? filters.status : 0,
            VisitType:
              filters.visitType && filters.visitType !== "all"
                ? filters.visitType
                : 0,
            StartDate: filters.fromDate || 0,
            EndDate: filters.toDate || 0,
          },
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (data?.status) {
        setData(data.ResultData || []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to load");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!superIdData || !tokenData) return;

    fetchVisitingData({
      visitType: selectedVisitType,
      status: selectedStatus,
      fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
      toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
    });
  }, [superIdData, tokenData, selectedVisitType, selectedStatus, dateRange]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchEmployees = async () => {
      try {
        const response = await axios.get(
          `${ROLL_CALL_API_BASE_URL}portal/emp/getemployeedropdown`,
          {
            params: {
              superid: superIdData,
              BranchId: 0,
              DeptId: 0,
            },
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        if (response.data.status) {
          setEmployees(response.data.ResultData);
        }
      } catch (err) {
        console.error("Employee fetch error:", err);
      }
    };

    fetchEmployees();
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (visitCanvas.mode === "edit" && visitCanvas.record?.Duration) {
      const now = new Date();
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 0, 0);

      const diffMinutes = Math.ceil((endOfDay - now) / (1000 * 60));

      if (Number(visitCanvas.record.Duration) >= diffMinutes) {
        setIsFullDay(true);
      } else {
        setIsFullDay(false);
      }
    }
  }, [visitCanvas.mode, visitCanvas.record]);

  const handleApprove = async (record) => {
    Swal.fire({
      title: "Approve Visit?",
      text: "Are you sure you want to approve this visit request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = {
            AppointmentId: record.AppointmentId,
            Status: 1,
            UpdatedBy: superIdData,
          };

          const response = await axios.post(
            `${ROLL_CALL_API_BASE_URL}Visitor/Pass/UpdatevisitorStatus`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (response.data.status) {
            // show success first
            await Swal.fire({
              icon: "success",
              title: "Approved!",
              text: "The visit has been approved successfully.",
              confirmButtonText: "OK",
            });

            // then fetch updated list
            fetchVisitingData({
              visitType: selectedVisitType,
              status: selectedStatus,
              fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
              toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
            });
          } else {
            Swal.fire("Error", "Failed to approve visit", "error");
          }
        } catch (error) {
          console.error("Approve visit error:", error);
          Swal.fire("Error", "Something went wrong!", "error");
        }
      }
    });
  };

  const handleReject = async (record) => {
    Swal.fire({
      title: "Reject Visit",
      text: "Are you sure you want to reject this visit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = {
            AppointmentId: record.AppointmentId,
            UpdatedBy: superIdData,
          };

          const response = await axios.post(
            `${ROLL_CALL_API_BASE_URL}Visitor/Pass/deletevisitor`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (response.data.status) {
            await Swal.fire({
              icon: "success",
              title: "Rejected!",
              text: "The visit has been rejected successfully.",
              confirmButtonText: "OK",
            });

            fetchVisitingData({
              visitType: selectedVisitType,
              status: selectedStatus,
              fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
              toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
            });
          } else {
            Swal.fire("Error", "Failed to reject visit", "error");
          }
        } catch (error) {
          console.error("Reject visit error:", error);
          Swal.fire("Error", "Something went wrong!", "error");
        }
      }
    });
  };

  const handleUpdate = async () => {
    try {
      if (!visitCanvas.record) return;

      setLoading(true);

      if (!visitCanvas.record?.StartDateTime) {
        Swal.fire("Error", "Invalid date selected", "error");
        return;
      }

      const cleanDate = visitCanvas.record.StartDateTime.replace("Z", "").slice(
        0,
        16,
      );

      const transactionDate = cleanDate.split("T")[0];
      const startDateTime = cleanDate + ":00";

      const payload = {
        AppointmentId: visitCanvas.record.AppointmentId,
        Mobile: visitCanvas.record.Mobile,
        Duration: Number(visitCanvas.record.Duration),
        TransactionDate: transactionDate,
        StartDateTime: startDateTime,
        UpdatedBy: userData?.RegId,
      };

      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}Visitor/Pass/editvisitor`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Visit updated successfully.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            fetchVisitingData({
              visitType: selectedVisitType,
              status: selectedStatus,
              fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
              toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
            });

            closeCanvas();
          }
        });
      } else {
        Swal.fire("Error", response.data.message || "Update failed", "error");
      }
    } catch (error) {
      console.error("Update Error:", error);
      Swal.fire("Error", "Something went wrong while updating", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    // Reset all filters
    setSelectedVisitType(0);
    setSelectedStatus(undefined);
    setDateRange(null);

    // Fetch fresh data
    fetchVisitingData({
      visitType: 0,
      status: undefined,
      fromDate: undefined,
      toDate: undefined,
    });
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Visiting List", 14, 10);

    const rows = data.map((r) => [
      r.Name || "N/A",
      formatDate(r.StartDateTime),
      `${r.CheckInTime || "N/A"} - ${r.CheckOutTime || "N/A"}`,
      visitTypeMap[r.VisitType] || "Unknown",
      r.HostedByName || "N/A",
      r.RequestedByName || "N/A",
      r.Purpose || "N/A",
      statusMap[r.Status] || "Unknown",
    ]);

    doc.autoTable({
      head: [
        [
          "Visitor Name",
          "Date & Time",
          "Check In & Out",
          "Visit Type",
          "Meeting With",
          "Requested By",
          "Purpose",
          "Status",
        ],
      ],
      body: rows,
      startY: 20,
    });

    doc.save("Visiting_List.pdf");
  };

  const exportExcel = () => {
    const exportData = data.map((r) => ({
      "Visitor Name": r.Name || "N/A",
      "Date & Time": formatDate(r.StartDateTime),
      "Check In & Out": `${r.CheckInTime || "N/A"} - ${r.CheckOutTime || "N/A"}`,
      "Visit Type": visitTypeMap[r.VisitType] || "Unknown",
      "Meeting With": r.HostedByName || "N/A",
      "Requested By": r.RequestedByName || "N/A",
      Purpose: r.Purpose || "N/A",
      Status: statusMap[r.Status] || "Unknown",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Visiting List");

    XLSX.writeFile(wb, "Visiting_List.xlsx");
  };
  const handleShareWhatsApp = async (record) => {
    try {
      await axios.post(
        `${ROLL_CALL_API_BASE_URL}Visitor/Pass/resendapptdetails`,
        {
          AppointmentId: record.AppointmentId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      await Swal.fire({
        title: "Success",
        text: "Visitor pass sent to WhatsApp",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(error);

      await Swal.fire({
        title: "Error",
        text: "Failed to send WhatsApp message",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <style>
        {`
   

    .ctc-table1 .ant-table-thead > tr > th {
      background-color: #d2e6f5ff !important; 
    }

    .ctc-table1 table {
      table-layout: auto;
    }

    .ctc-info-2col {
      display: grid;
      column-gap: 10px;
      row-gap: 8px;
    }

    .ctc-pair {
      display: flex;
      align-items: flex-start;
    }

    .ctc-label {
      font-weight: 600;
    }

    .ctc-value {
      font-weight: 500;
    }
  `}
      </style>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item">Visit List</h4>
                  </ol>
                </nav>
                <h6>Manage your visit List</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>PDF</Tooltip>}
                >
                  <Link onClick={exportPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="pdf"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Excel</Tooltip>}
                >
                  <Link onClick={exportExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Refresh</Tooltip>}
                >
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "></i>
                </Link>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>
              <div className="col-lg-auto col-md-12 mt-md-5 mt-sm-5 mt-lg-0">
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  {/* Year */}
                  <div className="me-2">
                    <RangePicker
                      format="DD-MM-YYYY"
                      presets={rangePresets}
                      onChange={onRangeChange}
                    />
                  </div>

                  {/* Visit Type */}
                  <div className="me-2">
                    <Select
                      value={visitTypeOptions.find(
                        (opt) => opt.value === selectedVisitType,
                      )}
                      style={{ width: 150 }}
                      onChange={(option) =>
                        setSelectedVisitType(option?.value || 0)
                      }
                      options={visitTypeOptions}
                    />
                  </div>

                  {/* Status */}
                  <div className="me-2">
                    <Select
                      value={statusOptions.find(
                        (opt) => opt.value === selectedStatus,
                      )}
                      style={{ width: 150 }}
                      onChange={(option) => setSelectedStatus(option?.value)}
                      options={statusOptions}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body pb-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    pgno={true}
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <CommonFooter />
        <AddVisit
          isOpen={showAdd}
          onClose={() => setShowAdd(false)}
          onAdd={() => {
            fetchVisitingData({
              visitType: selectedVisitType,
              status: selectedStatus,
              fromDate: dateRange?.[0]?.format("YYYY-MM-DD"),
              toDate: dateRange?.[1]?.format("YYYY-MM-DD"),
            });
          }}
        />
        {visitCanvas.show && (
          <>
            {/* Backdrop */}
            <div
              className="offcanvas-backdrop fade show"
              onClick={closeCanvas}
            />

            <div
              className={`offcanvas offcanvas-end ${visitCanvas.show ? "show" : ""}`}
              tabIndex={-1}
              style={{
                minWidth: "38%",
                maxWidth: "38%",
                visibility: visitCanvas.show ? "visible" : "hidden",
              }}
            >
              <div className="offcanvas-header py-3">
                <h4 className="mb-0">
                  {visitCanvas.mode === "view"
                    ? "View Visitings"
                    : "Edit Visitings"}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeCanvas}
                />
              </div>

              <hr className="my-1" />

              <div className="offcanvas-body pt-0">
                {visitCanvas.record && (
                  <>
                    {(visitCanvas.mode === "view" ||
                      visitCanvas.mode === "edit") && (
                      <>
                        <div className="mt-2">
                          <h6 className="mb-2">Visitor Details</h6>
                          <div className="border rounded p-2 mb-3 bg-light">
                            <div className="d-flex justify-content-between mb-2">
                              <span>
                                Visitor <span className="text-danger">*</span>
                              </span>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <input
                                  className="form-control form-control-sm"
                                  placeholder="Visitor Name"
                                  value={visitCanvas.record?.Name || ""}
                                  disabled={!isFieldEditable("Name")}
                                  onChange={(e) =>
                                    setVisitCanvas((prev) => ({
                                      ...prev,
                                      record: {
                                        ...prev.record,
                                        Name: e.target.value,
                                      },
                                    }))
                                  }
                                />
                              </div>

                              <div className="col-md-6 mb-2">
                                <input
                                  className="form-control form-control-sm"
                                  placeholder="Mobile"
                                  value={visitCanvas.record?.Mobile || ""}
                                  disabled={!isFieldEditable("Mobile")}
                                  onChange={(e) =>
                                    setVisitCanvas((prev) => ({
                                      ...prev,
                                      record: {
                                        ...prev.record,
                                        Mobile: e.target.value,
                                      },
                                    }))
                                  }
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <input
                                  type="email"
                                  className="form-control form-control-sm"
                                  placeholder="Email"
                                  value={visitCanvas.record?.Email || ""}
                                  disabled={!isFieldEditable("Email")}
                                  onChange={(e) =>
                                    setVisitCanvas((prev) => ({
                                      ...prev,
                                      record: {
                                        ...prev.record,
                                        Email: e.target.value,
                                      },
                                    }))
                                  }
                                />
                              </div>

                              <div className="col-md-6 mb-2">
                                <input
                                  className="form-control form-control-sm"
                                  placeholder="Vehicle No"
                                  value={visitCanvas.record?.VehicleNo || ""}
                                  disabled={!isFieldEditable("VehicleNo")}
                                  onChange={(e) =>
                                    setVisitCanvas((prev) => ({
                                      ...prev,
                                      record: {
                                        ...prev.record,
                                        VehicleNo: e.target.value,
                                      },
                                    }))
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {(visitCanvas.mode === "view" ||
                      visitCanvas.mode === "edit") && (
                      <div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Date & Time{" "}
                              {visitCanvas.mode === "edit" && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              value={
                                visitCanvas.record.StartDateTime
                                  ? visitCanvas.record.StartDateTime.slice(
                                      0,
                                      16,
                                    )
                                  : ""
                              }
                              disabled={!isFieldEditable("StartDateTime")}
                              onChange={(e) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    StartDateTime: e.target.value,
                                  },
                                }))
                              }
                            />
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="d-flex justify-content-between align-items-center">
                              <label className="form-label mb-0">
                                Duration
                              </label>

                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="editFullDayCheck"
                                  checked={isFullDay}
                                  disabled={!isFieldEditable("Duration")}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setIsFullDay(checked);

                                    if (checked) {
                                      const now = new Date();
                                      const endOfDay = new Date();
                                      endOfDay.setHours(23, 59, 0, 0);

                                      const diffMinutes = Math.ceil(
                                        (endOfDay - now) / (1000 * 60),
                                      );

                                      setVisitCanvas((prev) => ({
                                        ...prev,
                                        record: {
                                          ...prev.record,
                                          Duration: diffMinutes.toString(),
                                        },
                                      }));
                                    } else {
                                      setVisitCanvas((prev) => ({
                                        ...prev,
                                        record: {
                                          ...prev.record,
                                          Duration: "60",
                                        },
                                      }));
                                    }
                                  }}
                                />
                                <label
                                  className="form-check-label ms-1"
                                  htmlFor="editFullDayCheck"
                                >
                                  All day
                                </label>
                              </div>
                            </div>

                            <Select
                              options={durationOptions}
                              value={
                                durationOptions.find(
                                  (option) =>
                                    option.value ===
                                    visitCanvas.record?.Duration?.toString(),
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    Duration: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  },
                                }))
                              }
                              placeholder="-- Select Duration --"
                              isClearable
                              isDisabled={isFullDay || isView}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Visit Type{" "}
                              {visitCanvas.mode === "edit" && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <Select
                              options={visitTypeOptions
                                .filter((v) => v.value !== 0)
                                .map((v) => ({
                                  label: v.label,
                                  value: v.value,
                                }))}
                              value={
                                visitTypeOptions
                                  .filter((v) => v.value !== 0)
                                  .map((v) => ({
                                    label: v.label,
                                    value: v.value,
                                  }))
                                  .find(
                                    (opt) =>
                                      opt.value ===
                                      visitCanvas.record.VisitType,
                                  ) || null
                              }
                              onChange={(selected) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    VisitType: selected ? selected.value : "",
                                  },
                                }))
                              }
                              isDisabled={!isFieldEditable("VisitType")}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Meeting With{" "}
                              {visitCanvas.mode === "edit" && (
                                <span className="text-danger">*</span>
                              )}
                            </label>

                            <Select
                              options={employees.map((emp) => ({
                                value: emp.RegId,
                                label: emp.UserWithBadge,
                              }))}
                              value={
                                employees
                                  .map((emp) => ({
                                    value: emp.RegId,
                                    label: emp.UserWithBadge,
                                  }))
                                  .find(
                                    (opt) =>
                                      opt.value === visitCanvas.record.HostedBy,
                                  ) || null
                              }
                              onChange={(selected) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    HostedBy: selected ? selected.value : "",
                                  },
                                }))
                              }
                              isDisabled={!isFieldEditable("HostedBy")}
                              placeholder="-- Search & Select --"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Requested By{" "}
                              {visitCanvas.mode === "edit" && (
                                <span className="text-danger">*</span>
                              )}
                            </label>

                            <Select
                              options={employees.map((emp) => ({
                                value: emp.RegId,
                                label: emp.UserWithBadge,
                              }))}
                              value={
                                employees
                                  .map((emp) => ({
                                    value: emp.RegId,
                                    label: emp.UserWithBadge,
                                  }))
                                  .find(
                                    (opt) =>
                                      opt.value ===
                                      visitCanvas.record.RequestedBy,
                                  ) || null
                              }
                              onChange={(selected) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    RequestedBy: selected ? selected.value : "",
                                  },
                                }))
                              }
                              isDisabled={!isFieldEditable("RequestedBy")}
                              placeholder="-- Search & Select --"
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Company Name</label>
                            <input
                              type="text"
                              className="form-control "
                              disabled={!isFieldEditable("CompanyName")}
                              value={visitCanvas.record.CompanyName}
                              onChange={(e) =>
                                setVisitCanvas((prev) => ({
                                  ...prev,
                                  record: {
                                    ...prev.record,
                                    CompanyName: e.target.value,
                                  },
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Purpose{" "}
                            {visitCanvas.mode === "edit" && (
                              <span className="text-danger">*</span>
                            )}
                          </label>
                          <input
                            className="form-control"
                            value={visitCanvas.record.Purpose}
                            disabled={!isFieldEditable("Purpose")}
                            onChange={(e) =>
                              setVisitCanvas((prev) => ({
                                ...prev,
                                record: {
                                  ...prev.record,
                                  Purpose: e.target.value,
                                },
                              }))
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                      <button
                        className="btn btn-secondary"
                        onClick={closeCanvas}
                      >
                        Cancel
                      </button>

                      {visitCanvas.mode === "edit" && (
                        <button
                          className="btn btn-success"
                          disabled={loading}
                          onClick={handleUpdate}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                              />
                              Updating...
                            </>
                          ) : (
                            "Update"
                          )}
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default VisitorList;
